import { render } from "./noauth-layout.vue?vue&type=template&id=4ea0e543&ts=true"
import script from "./noauth-layout.vue?vue&type=script&lang=ts"
export * from "./noauth-layout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__